module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Icon.1d6191b9.png";